import * as React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Button,
  Label,
  Input,
  Menu,
  MenuList,
  MenuItem,
  MenuPopover,
  MenuTrigger,
  MenuSplitGroup,
  Text,
} from "@fluentui/react-components";
import CommonTooltip from "../../common/CommonTooltip";
import { iconsDb } from "../../../assets/iconsDB.gen";
import HarveyBall from "../../../assets/icons/harvey/HarveyBall";
import { LazyIcon } from "../../common/LazyIcon";

export const IconSelectorButton = ({ icon, onClick }) => {
  return (
    <div style={{ padding: 0, margin: 0, minWidth: 0 }}>
      <CommonTooltip content={icon.tags?.join(", ")}>
        <Button
          id={`${icon.id}_icon_button`}
          appearance="subtle"
          style={{ minWidth: 0, padding: 2 }}
          onClick={() => onClick(icon)}
        >
          {icon?.type === "harvey" ? (
            <HarveyBall type={icon.icon ?? icon} size={24} />
          ) : (
            <LazyIcon name={icon.name} size={24} source={icon.source} />
          )}
        </Button>
      </CommonTooltip>
    </div>
  );
};

IconSelectorButton.propTypes = {
  icon: PropTypes.shape({
    tags: PropTypes.array.isRequired,
    icon: PropTypes.any,
    id: PropTypes.string.isRequired,
    comp: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    source: PropTypes.string,
  }),
  onClick: PropTypes.func.isRequired,
};

const IconSelectorSubMenu = (props) => {
  const { t } = useTranslation();
  const [searchString, setSearchString] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize] = useState(24);

  return (
    <Menu openOnHover={true}>
      {props.onDelete ? (
        <MenuSplitGroup>
          <MenuItem onClick={() => props.onDelete()}>{t("menu.insert.icon")} (X)</MenuItem>
          <MenuTrigger>
            <MenuItem />
          </MenuTrigger>
        </MenuSplitGroup>
      ) : (
        <MenuTrigger>
          <MenuItem>{t("menu.insert.icon")}</MenuItem>
        </MenuTrigger>
      )}
      <MenuPopover>
        <MenuList>
          <Input
            placeholder={t("menu.insert.icon.search")}
            value={searchString}
            onChange={(e, data) => {
              setSearchString(data.value);
              setPage(0);
            }}
          />
          {searchString === null || searchString.length === 0 ? (
            <>
              <Label>{t("menu.insert.icon.favs")}</Label>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto auto auto auto auto auto",
                }}
              >
                {iconsDb.slice(0, 6).map((icon, i) => (
                  <IconSelectorButton
                    icon={{ id: icon.id, icon: icon.icon, tags: icon.tags, type: icon.type }}
                    key={i}
                    onClick={props.onClick}
                  />
                ))}
              </div>
              <Label>{t("menu.insert.icon.all")}</Label>
            </>
          ) : (
            <></>
          )}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto auto auto auto auto auto",
            }}
          >
            {iconsDb
              .filter((icon) => {
                if (!searchString) return true;
                const searchPhrases = searchString.toLowerCase().split(" ");
                let allPhraseFound = true;
                for (let i = 0; i < searchPhrases.length; i++) {
                  const phrase = searchPhrases[i];
                  if (!icon.tags.some((tag) => tag.startsWith(phrase))) {
                    allPhraseFound = false;
                    break;
                  }
                }
                return allPhraseFound;
              })
              .slice(page * pageSize, (page + 1) * pageSize) // paging
              .map((icon, i) => (
                <IconSelectorButton
                  icon={{ id: icon.id, icon: icon.icon, tags: icon.tags, comp: icon.type }}
                  key={i}
                  onClick={props.onClick}
                />
              ))}
          </div>

          <div>
            <Button onClick={() => setPage(Math.max(0, page - 1))}>Prev</Button>
            <Text>{page}</Text>
            <Button onClick={() => setPage(page + 1)}>Next</Button>
          </div>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

IconSelectorSubMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
};

export default IconSelectorSubMenu;
